<div class="sac-transports"
  [ngStyle]="{ 'width.px': listWidth , 'min-width.px': listWidth , 'max-width.px': listWidth }">
  <sc-flex [fitHeight]="true" [stretchContent]="true" [vertical]="true">
    <ng-container *ngIf="featureMovingOrderActive||featurePlannedTransportsActive">
      <sc-flex>
        <sc-content-spacer [grow]="true"></sc-content-spacer>
        <button mat-stroked-button (click)="managePlannedAssignments()" *ngIf="featurePlannedTransportsActive"
          [disabled]="selection?.station?.stationType !== stationType.WORKING_AREA || !selection?.station?.stationUsage?.plannedTransportAssignmentPossible"
          title="{{'planned assignments' |
        translate:['tmc-yard.widgets.sac-client.sac-transports.action.planned-assignments',
        translationService.language]}}">
          <mat-icon><sc-icon iconClass="fa-truck-clock"></sc-icon></mat-icon>
        </button>
        <sc-content-spacer [grow]="false" *ngIf="featureMovingOrderActive"></sc-content-spacer>
        <button mat-stroked-button (click)="createMovingOrder()" *ngIf="featureMovingOrderActive" [disabled]="!selection?.station?.stationUsage?.createMovementOrderPossible" title="{{'create moving order' |
           translate:['tmc-yard.widgets.sac-client.sac-transports.action.create-moving-order',
           translationService.language]}}">
          <mat-icon><sc-icon iconClass="fa-truck-arrow-right"></sc-icon></mat-icon>
        </button>
      </sc-flex>
      <sc-content-spacer [vertical]="true"></sc-content-spacer>
    </ng-container>
    <sc-flex-fitting-content [vertical]="true">
      <sc-scroll-pane>
        <div class="transport-group" *ngFor="let transportGroup of transportGroups">
          <ng-container *ngIf="transportGroup.transports.length > 0 || transportGroup.key === 'transports'">

            <sc-sub-title>{{'' | translate:[transportGroup.nameDictionaryKey,
              translationService.language]}}</sc-sub-title>

          </ng-container>

          <div class="no-transport-hint"
            *ngIf="transportGroup.transports.length === 0 && transportGroup.key === 'transports'">
            {{'no transports available' | translate:['tmc-yard.widgets.sac-client.sac-transports.empty',
            translationService.language]}}
          </div>

          <sc-content-spacer [vertical]="true"></sc-content-spacer>

          <div class="transport-list">

            <ng-container *ngFor="let transport of transportGroup.transports">

              <app-transport-list-entry [transport]="transport" [dashboardContext]="dashboardContext"
                [selected]="selectedTransportId != null && transport.id === selectedTransportId && selectedTransportGroupKey === transportGroup.key"
                (click)="setSelectedTransport(transportGroup, transport)"></app-transport-list-entry>

              <ng-container *ngIf="selectedTransportId != null && transport.id === selectedTransportId">
                <app-transport-details-list-entry [transport]="transport" [dashboardContext]="dashboardContext"
                  [station]="selection.station" [stationSet]="selection.stationSet"></app-transport-details-list-entry>
              </ng-container>

              <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
            </ng-container>

          </div>

          <sc-content-spacer [vertical]="true"></sc-content-spacer>

        </div>
      </sc-scroll-pane>
    </sc-flex-fitting-content>
  </sc-flex>
</div>
